<template>
    <div>
        <div class="el-div">
        </div>
        <div style="width: 90%;height: 90%;margin-left: 5%;">
            <el-row gutter="25">
                <el-image style="width: 80%;height: 80%;margin-left: 10%"
                          :src="'data:image/'+product.imgType+';base64,'+product.imgSmall">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>

                <el-row  :gutter="20">
                    <el-col :span="24">
                        <h2>品名：{{product.prodName}}</h2>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <p>积分：{{product.price}}积分</p>
                    </el-col>
                    <el-col :span="8">
                        <p>存量：{{product.productStorage.amount}}</p>
                    </el-col>
                    <el-col :span="8">

                    </el-col>
                </el-row>
                <el-row style="text-align: right"  :gutter="20">
                    <el-button type="warning" size="samll" icon="el-icon-shopping-cart-full" round @click="doOrder"> 立即兑换</el-button>
                </el-row>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
      name: "ProductDetail",
      data() {
        return {
          product: {},
          modulePrpty:""
        }
      },
      methods: {
        doOrder() {
          this.$router.push({
            path: "/order/submit",
            query: {product: this.product.productId,modulePrpty:this.modulePrpty}
          });
        }
      },
      activated() {
        this.product = {}
        console.log(this.$route.params.product)
        this.product = this.$route.params.product
        this.modulePrpty=this.$route.params.modulePrpty
      },
      created(){
        // this.product = {}
        // console.log(this.$route.params.product)
        // this.product = this.$route.params.product
      },
      mounted() {
        this.product = {}

        this.product = this.$route.params.product
        this.modulePrpty=this.$route.params.modulePrpty
          console.log("detail:this.modulePrpty:"+this.modulePrpty)
      }
    }
</script>

<style>
    .el-div {
        width: 100% !important;
        height: 8vh !important;
        text-align: center !important;
        background-size: 100% 100% !important; /*按比例缩放*/
        background-image: url("../../assets/images/classChannel/xxpd-tou.jpg");
    }
</style>
